import { type FC, useMemo } from "react";
import moment from "moment";
import type { SlideShowComponentSettings } from "../../../Routes/Settings/CustomerDisplay/CustomerDisplayTypes";
import Slideshow, { type SlideshowSlideType } from "../../Slideshow/Slideshow";
import type { CustomerDisplayComponentProps } from "../CustomerDisplay";

interface Props extends CustomerDisplayComponentProps<SlideShowComponentSettings, null> {}

export const CustomerDisplaySlideShow: FC<Props> = ({ settings }) => {
    const style = {
        backgroundColor: settings.background,
        color          : settings.color,
    };

    const slides = useMemo(() => {
        const slides: Array<SlideshowSlideType> = [];

        for(const slide of settings.slides) {
            const now = new Date();

            if(slide.startDate) {
                const parsedStart = moment(slide.startDate);

                if(parsedStart.isAfter(now)) {
                    continue;
                }
            }

            if(slide.endDate) {
                const parsedEnd = moment(slide.endDate);

                if(parsedEnd.isBefore(now)) {
                    continue;
                }
            }

            let duration: number;

            if(typeof slide.duration === "string") {
                const parsed = parseFloat(slide.duration);

                if(isNaN(parsed)) {
                    continue;
                }

                duration = parsed;
            } else {
                duration = slide.duration;
            }

            slides.push({
                type: slide.type,
                url : slide.url,
                duration,
            });
        }

        return slides;
    }, [ settings.slides ]);

    return (
        <div className="customer-display-slide-show w-full h-full" style={style}>
            <Slideshow
                media={slides}
                style={{
                    position: "relative",
                    width   : "100%",
                    height  : "100%",
                }}
                fill={settings.fill}
                cover={settings.cover}
            />
        </div>
    );
};
